export default {
  getColunas(state) {
    return state.colunasEmpresas;
  },
  getEmpresas(state) {
    return state.empresas;
  },
  getFiltros(state) {
    return state.filtros;
  },
  getFiltrosQuestionarios(state) {
    return state.filtrosQuestionarios;
  },
  getFiltrosPerguntas(state) {
    return state.filtrosPerguntas;
  },
  getResponsaveisComex(state) {
    return state.responsaveisComex;
  },
  getResponsaveisExecutivos(state) {
    return state.responsaveisExecutivos;
  },
  getEmpresaDNA(state) {
    return state.empresaDNA;
  },
  getCampos(state) {
    return state.campos;
  },
  getColDefault(state) {
    return state.colDefault;
  },
  getDirectionDefault(state) {
    return state.directionDefault;
  },
};
